<template>
    <modal 
        :name="name"
        @before-open="beforeOpen"
        :widt="width"
        :height="height"
        class="download-report-container"
    >
        <div class="params-header">
            <div class="option-title">Report Configuration</div>
            <div class="modal-actions">
                <div class="btn btn--primary" @click="close">Cancel</div>
                <div class="btn btn--primary" v-bind:class= "emptyAttr ? 'disabled' : ''" @click="doExport">Export</div>
            </div>
        </div>
        <div>
            <div class="plot-amount-selector">
                <div class="section-title">Choose the plots you would like to add</div>
                <multi-select-component
                    mode="single"
                    v-model="plotCount"
                    :options=[1,2,3]
                    :configurationOptions="{ 'allow-empty': false }"
                ></multi-select-component>
            </div>
            <div class="attr-selectors control-block half-selectors" v-for="(plot,i) in plotCount" :key="plot">
                <div class="plot-number">P{{plot}}</div>
                <div class="selector dropdown">
                    <multi-select-component
                    :label="$t('x_axis')"
                    mode="single"
                    v-model="xAttrs[i]"
                    :options="availableAttrsX"
                    :configurationOptions="{ 'allow-empty': false }"
                    ></multi-select-component>
                </div>
                <div class="selector dropdown">
                    <multi-select-component
                    :label="$t('y_axis')"
                    mode="single"
                    v-model="yAttrs[i]"
                    :options="availableAttrsY"
                    :configurationOptions="{ 'allow-empty': false }"
                    ></multi-select-component>
                </div>
                <div class="selector dropdown">
                    <multi-select-component
                    label="Color Grouping By"
                    mode="single"
                    v-model="colorTags[i]"
                    :options="availableTags"
                    ></multi-select-component>
                </div>
                <div class="selector dropdown">
                    <multi-select-component
                    label="Regressions To Show"
                    mode="multiple"
                    v-model="regressionGroupsToShow[i]"
                    :options="colorTags[i] == null ? [] : Object.keys(colorGroupsPerTag[colorTags[i]])"
                    ></multi-select-component>
                </div>
            </div>
        </div>
    </modal>
</template>


<script>
import MultiSelectComponent from '@/components/MultiSelectComponent'
import OptionCard from '@/components/commons/OptionCard'

export default {
    name: 'ModalCustomReport',
    components: {MultiSelectComponent, OptionCard},
    props: ['name', 'width', 'height', 'availableAttrsX', 'availableAttrsY', 'availableTags'],
    data() {
        return {
            plotCount: 1,
            xAttrs: [null],
            yAttrs: [null],
            colorTags: [null],
            regressionGroupsToShow: [],
            colorGroupsPerTag: {}
        }
    },  
    methods: {
        beforeOpen(event) {
            this.colorGroupsPerTag = event.params.colorGroupsPerTag
        },
        doExport() {
            this.$emit('export', {xAttrs: this.xAttrs, yAttrs: this.yAttrs, colorTags: this.colorTags, regressionGroupsToHide: this.regressionGroupsToHide} )
        },
        close(){
            this.$modal.hide(this.name)
        }
    },
    computed: {
        regressionGroupsToHide() {
            let regressionsToHide = []
            this.colorTags.forEach((thisTag,i) => {
                if (thisTag) {
                    let thisTagGroups = Object.keys(this.colorGroupsPerTag[thisTag])
                    if (this.regressionGroupsToShow[i]) regressionsToHide.push(thisTagGroups.filter(group => !this.regressionGroupsToShow[i].includes(group)))
                    else regressionsToHide.push(thisTagGroups)
                } else {
                    regressionsToHide.push([null])
                }
            })
            return regressionsToHide
        },
        emptyAttr() {
            return this.xAttrs.some(attr => attr == null) || this.yAttrs.some(attr => attr == null)
        }
    },
    watch: {
        plotCount() {
            if (this.xAttrs.length < this.plotCount) {
                for (let i=this.xAttrs.length; i<this.plotCount; i++) {
                    this.xAttrs.push(null)
                    this.yAttrs.push(null)
                    this.colorTags.push(null)
                }
            } else {
                this.xAttrs.length = this.plotCount
                this.yAttrs.length = this.plotCount
                this.colorTags.length = this.plotCount
            }
        }
    },
}
</script>


<style lang="stylus" scoped>
.download-report-container
  background-color: rgba(#000, 0.5)
  display: flex

  .plot-amount-selector
    margin: 20px 0 20px
    display: flex
    flex-direction: row
    align-items: center

  .control-block
      border-bottom: solid 1px $gull-gray
      padding: 10px 10px 30px 10px
      margin: 10px 20px
      position: relative

      &.half-selectors

        .plot-number
            m-font-size(14,16)
            color: $gull-gray
            position: absolute
            bottom: 0
            left: 0
            margin-right: 20px
        .selector
          width: 45%

          &:not(:last-child)
            margin-right: 5px

    .attr-selectors
      display: flex

      .selector
        display: flex
        flex-direction: column


  >>> .vm--modal
    background: rgb(239, 239, 242)
    background: linear-gradient(180deg, rgba(239, 239, 242, 1) 0, rgba(206, 208, 217, 1) 100%)
    display: inline-block
    flex-direction: column

  .params-header
    display: flex
    margin: 10px 20px
    align-items: baseline
    .modal-actions
      margin-left: auto
      display flex
      max-height 32px
  .option-title
    m-font-size(28, 32)
    font-weight: $fw-light
    overflow-wrap: anywhere

  .section-title
    margin: 10px 20px
    m-font-size(16, 18)
    color: $gull-gray
    font-weight: $fw-light
    text-transform: uppercase

    
</style>